<template>
	<div>
		<div class="list_top_box">
			<h3>Current Stock</h3>
			<p class="mgb_5">
				<span>As of: {{ as_of_date }}</span>
				<span style="float: right;"><b>Currency: $</b></span>
			</p>
		</div>
		<div style="overflow: auto; min-height: 320px; max-height: 360px;">
			<div class="col_6" style="padding-right: 10px;">
				<h4 class="mgb_5">By Collection</h4>
				<table class="tbl_list">
					<thead>
						<tr>
							<th class="al_left">Collection</th>
							<th class="al_right">QTY</th>
							<th class="al_right">Stock Value ($)</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="row in collection_rows" :key="row.collection">
							<td class="al_left">{{ row.collection }}</td>
							<td class="al_right">{{ row.qty | commaSeparated }}</td>
							<td class="al_right">{{ row.stock_value | toCurrency }}</td>
						</tr>
						<tr v-if="collection_rows.length > 0" class="bg_gray">
							<td class="al_left"><b>TOTAL</b></td>
							<td class="al_right">
								<b>{{ collection_total.qty | commaSeparated }}</b>
							</td>
							<td class="al_right">
								<b>{{ collection_total.stock_value | toCurrency }}</b>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col_6" style="padding-left: 10px;">
				<h4 class="mgb_5">By Category</h4>
				<table class="tbl_list">
					<thead>
						<tr>
							<th class="al_left">Category</th>
							<th class="al_right">QTY</th>
							<th class="al_right">Stock Value ($)</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="row in category_rows" :key="row.category">
							<td class="al_left">{{ row.category }}</td>
							<td class="al_right">{{ row.qty | commaSeparated }}</td>
							<td class="al_right">{{ row.stock_value | toCurrency }}</td>
						</tr>
						<tr v-if="category_rows.length > 0" class="bg_gray">
							<td class="al_left"><b>TOTAL</b></td>
							<td class="al_right">
								<b>{{ category_total.qty | commaSeparated }}</b>
							</td>
							<td class="al_right">
								<b>{{ category_total.stock_value | toCurrency }}</b>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { apiGetCurrentStockArkin } from '@/api/statistics/statistics.js';
import { today } from '@/utils/date.js';
export default {
	data: () => ({
		rows: [],
		as_of_date: today(),
	}),
	computed: {
		category_rows() {
			return this.rows.map(r => ({
				category: r.category,
				qty: Number(r.qty) || 0,
				stock_value: Number(r.stock_value) || 0,
			}));
		},
		collection_rows() {
			const map = {};
			for (const r of this.rows) {
				const key = r.collection;
				if (!map[key]) map[key] = { collection: key, qty: 0, stock_value: 0 };
				map[key].qty += Number(r.qty) || 0;
				map[key].stock_value += Number(r.stock_value) || 0;
			}
			const order = ['TOUCH', 'CATCH'];
			return Object.values(map).sort((a, b) => order.indexOf(a.collection) - order.indexOf(b.collection));
		},
		category_total() {
			return this.category_rows.reduce((acc, r) => ({ qty: acc.qty + r.qty, stock_value: acc.stock_value + r.stock_value }), { qty: 0, stock_value: 0 });
		},
		collection_total() {
			return this.collection_rows.reduce((acc, r) => ({ qty: acc.qty + r.qty, stock_value: acc.stock_value + r.stock_value }), { qty: 0, stock_value: 0 });
		},
	},
	methods: {
		async loadData() {
			const { data } = await apiGetCurrentStockArkin();
			this.rows = Array.isArray(data) ? data : [];
		},
	},
	created() {
		this.loadData();
	},
};
</script>

<style scoped>
.tbl_list {
	width: 100%;
	border-collapse: collapse;
}
.tbl_list th,
.tbl_list td {
	border: 1px solid #ddd;
	padding: 6px 8px;
}
.tbl_list thead th {
	background: #f5f7fa;
}
.bg_gray {
	background: #f5f7fa;
}
</style>
